// src/components/SearchBar.js

import React from 'react';
// We will import the CSS in the main ResourcesPage file

const SearchBar = ({ searchTerm, onSearchChange, onSearchSubmit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearchSubmit();
  };

  return (
    <form className="search-bar-form" onSubmit={handleSubmit}>
      <div className="search-bar-wrapper glossy-card">
        
        {/* Input Field */}
        <input
          type="text"
          placeholder="Search for specific topics, courses, or authors..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        
        {/* Search Button (The dark capsule) */}
        <button type="submit" className="search-button">
          {/* Magnifying Glass Icon (Using simple SVG for consistency) */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="search-icon"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </button>
      </div>
    </form>
  );
};

export default SearchBar;